import { Link } from "react-router-dom";
import { ShieldCheck, User, Stethoscope } from "lucide-react";

const Home = () => {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50 px-4">
      {/* TITLE */}
      <h1 className="text-4xl font-bold text-gray-800 mb-12 text-center">
        Hospital Management System
      </h1>

      {/* CARDS */}
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8 w-full max-w-6xl">
        
        {/* ADMIN */}
        <Link
          to="/admin-login"
          className="
            bg-white border rounded-2xl p-8 text-center
            shadow-md hover:shadow-xl
            transition-all duration-300
            hover:-translate-y-2
          "
        >
          <ShieldCheck className="w-14 h-14 text-blue-600 mx-auto mb-4" />
          <h2 className="text-2xl font-semibold mb-2">Admin Login</h2>
          <p className="text-gray-500 text-sm">
            Login as system administrator
          </p>
        </Link>

        {/* PATIENT */}
        <Link
          to="/patient-login"
          className="
            bg-white border rounded-2xl p-8 text-center
            shadow-md hover:shadow-xl
            transition-all duration-300
            hover:-translate-y-2
          "
        >
          <User className="w-14 h-14 text-green-600 mx-auto mb-4" />
          <h2 className="text-2xl font-semibold mb-2">Patient Login</h2>
          <p className="text-gray-500 text-sm">
            Access your health records
          </p>
        </Link>

        {/* DOCTOR */}
        <Link
          to="/employee-login"
          className="
            bg-white border rounded-2xl p-8 text-center
            shadow-md hover:shadow-xl
            transition-all duration-300
            hover:-translate-y-2
          "
        >
          <Stethoscope className="w-14 h-14 text-purple-600 mx-auto mb-4" />
          <h2 className="text-2xl font-semibold mb-2">Doctor Login</h2>
          <p className="text-gray-500 text-sm">
            Manage patients & appointments
          </p>
        </Link>

      </div>
    </div>
  );
};

export default Home;
